import Client from '@/repositories/AxiosClient';
const resource = '/core';

export default {
    get(type: string) {
        return Client().get(`${resource}/config?type=${type.trim()}`);
    },
};
